import { Pagination } from "@mui/material";
import { CaretLeftIcon, Cross1Icon, Cross2Icon } from "@radix-ui/react-icons";
import { PinLocation01Icon } from "hugeicons-react";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import {
  LISTE_COMMUNE_PRESTATAIRE,
  LISTE_EQUIPE_PRESTATAIRE,
  RETIRER_COMMUNE_PRESTATAIRE,
} from "../../Utils/constant";
import { Loader } from "../../components/Widget/Loader";
import { Tabs } from "../../components/Widget/Tab";
import { AddTeam } from "../../components/utilisateur/AddTeam";
import { deleteItem } from "../../services/service";
import { useEquipeStore } from "../../store/EquipeStore";
import { useStoreCommune } from "../../store/storeCommune";
import { Coordonnateur } from "../Coordonnateur/Coordonnateur";
import { AddPrestataireCommune } from "./AddPrestataireCommune";

export const DetailsPresataire = () => {
  const equipe = useEquipeStore();
  const communes = useStoreCommune();

  const [active, setActive] = useState({
    index: 0,
    value: "Equipes",
    label: "",
  });

  const filteredTabsData = [
    {
      index: 0,
      value: "Coordonnateurs",
      label: "",
    },
    {
      index: 1,
      value: "Communes",
      label: "",
    },
  ];

  const { id, name } = useParams();
  useEffect(() => {
    communes.getCommunePrestataire(
      `${LISTE_COMMUNE_PRESTATAIRE}/${id}?page=0&param=&size=10`
    );
    equipe.getEquipePrestataire(
      LISTE_EQUIPE_PRESTATAIRE + "/" + id,
      { page: 0, param: "", size: 10 },
      ""
    );
  }, []);

  const moreCommune = async (page) => {
    communes.getCommunePrestataire(
      `${LISTE_COMMUNE_PRESTATAIRE}/${id}?page=${page - 1}&param=&size=10`
    );
  };

  return (
    <div className="">
      <>
        <div className="flex items-center gap-2 my-2">
          <button
            className="btn bg-white btn-sm"
            onClick={() => {
              window.history.back();
            }}
          >
            <CaretLeftIcon />
          </button>

          <h3 class="font-mtn text-3xl font-bold">{name}</h3>
        </div>

        <Tabs
          tabsData={filteredTabsData}
          active={active}
          setActive={setActive}
        />
        <dialog id="add_Team" className="modal rounded-none">
          <div className="modal-box w-10/12 max-w-xl h-3/5">
            <div className="modal-action">
              <h1 className="mr-auto text-2xl font-bold font-mtn">
                Ajouter une equipe
              </h1>
              <form method="dialog">
                <button id="close_team" className="btn btn-sm">
                  <Cross2Icon />
                </button>
              </form>
            </div>
            <AddTeam prestataireId={Number(id)} />
          </div>
        </dialog>
        {active.index === 0 ? (
          <Coordonnateur />
        ) : (
          //////////////////////// COMMUNE /////////////////////////////////////////
          <>
            <div>
              <button
                onClick={() => {
                  document.getElementById("add_commune").showModal();
                }}
                className="my-3 ml-auto btn btn-sm bg-main rounded-md text-black text-xs hover:bg-gray-900 hover:text-white"
              >
                Ajouter une commune
              </button>
            </div>
            <dialog id="add_commune" className="modal rounded-none">
              <div className="modal-box w-10/12 max-w-xl h-3/5">
                <div className="modal-action">
                  <h1 className="mr-auto text-2xl font-bold font-mtn">
                    Ajouter une commune
                  </h1>
                  <form method="dialog">
                    <button
                      id="close_prestataire_commune"
                      className="btn btn-sm"
                    >
                      <Cross2Icon />
                    </button>
                  </form>
                </div>
                <AddPrestataireCommune designation={name} />
              </div>
            </dialog>

            <div className="grid md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-5 2xl:grid-cols-5 gap-2 my-8">
              {communes?.communePrestataire?.donnee?.length === 0 ? (
                ""
              ) : communes?.communePrestataire?.donnee?.length !== 0 &&
                !communes?.loading ? (
                communes?.communePrestataire?.donnee?.map((item) => (
                  <div className="relative flex gap-1 items-center cursor-pointer text-black shadow-sm border border-gray-100 bg-white rounded-full text-xs">
                    <div className="absolute right-2 top-2">
                      <div
                        onClick={() => {
                          deleteItem(
                            RETIRER_COMMUNE_PRESTATAIRE +
                              `?prestataireId=${id}&communeId=${item?.id}`
                          ).then((res) => {
                            if (res.status === 200) {
                              communes.getCommunePrestataire(
                                `${LISTE_COMMUNE_PRESTATAIRE}/${id}?page=0&param=&size=10`
                              );
                              toast.success("Retiré avec success");
                            }
                          });
                        }}
                        className="w-4 h-4 rounded-full flex items-center justify-center bg-gray-50"
                      >
                        <Cross1Icon size={20} />
                      </div>
                    </div>
                    <div className="bg-amber-100 w-8 h-8 rounded-full m-1 flex items-center justify-center">
                      <PinLocation01Icon size={18} className="text-amber-600" />
                    </div>
                    <div className="">
                      <p className="truncate w-28">{item?.designation}</p>
                    </div>
                  </div>
                ))
              ) : (
                <Loader />
              )}
            </div>
            <div className="my-3 flex justify-end">
              <Pagination
                onChange={(event, newValue) => moreCommune(newValue)}
                onSelect={(selectedPage) => moreCommune(selectedPage)}
                count={communes?.communePrestataire?.totalPages}
                variant="outlined"
                color="primary"
                shape="rounded"
              />
            </div>
          </>
        )}
      </>
    </div>
  );
};
